import { render, staticRenderFns } from "./ContractTermsBuilderEdit.vue?vue&type=template&id=dc19be84&"
import script from "./ContractTermsBuilderEdit.vue?vue&type=script&lang=js&"
export * from "./ContractTermsBuilderEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports